/**
 * Component to render SCA Special Edition page
 */
const SpecialEditionPage = (): React.ReactElement => {
  return (
    <div
      className="mb-10 font-public-sans"
      data-testid="special-edition-page-component"
    >
      <p>
        <strong>Objectives of the Award</strong>
      </p>

      <p>
        This award is to recognise exemplary companies that have upheld best
        practices in corporate governance and shown leadership, innovation and
        resilience during the pandemic. Despite the challenging circumstances,
        these companies have delivered sustainable financial performance and
        established frameworks and policies to create long-term value for the
        organisation, over the same period.
      </p>

      <p>
        In doing so, the SCA Organising Committee seeks to recognise and
        reinforce the notion that good corporate governance underpins strong
        performance, and provides a strong foundation for businesses to assess
        and adapt their strategies to the changing landscape. Excellence in
        corporate leadership – and good dynamics between board and management –
        helps build resilience to the challenging environment, and serves as a
        role model for other companies to emulate.
      </p>

      <p>
        <strong>Categories of the Award</strong>
      </p>

      <p>
        Awards will be presented to the companies in the following categories:
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Companies with market capitalisation of S$1 billion and above;</li>
        <li>
          Companies with market capitalisation of S$300 million to less than S$1
          billion;
        </li>
        <li>
          Companies with market capitalisation of less than S$300 million;
        </li>
      </ul>

      <p>
        <strong>Selection and Judging Process</strong>
      </p>

      <p>
        The selection for this Award goes through a rigorous three-stage
        process.
      </p>

      <p>
        In Stage 1, all listed companies are screened based on publicly
        available information of corporate governance practices, benchmark
        corporate governance indices and analysis of financial performance.
      </p>

      <p>A shortlist of approximately 60 companies will be developed.</p>

      <p>
        In Stage 2, additional inputs on shortlisted companies are obtained
        through research and discreet inquiries. The working committee will
        visit companies which are further shortlisted to interview and obtain
        more information on their board and management practices and processes.
      </p>

      <p>
        In Stage 3, a panel of judges will meet and conduct a final interview
        with selected companies to identify the winners.
      </p>

      <p>
        <strong>Award Criteria</strong>
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>
          CORPORATE GOVERNANCE
          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              The Singapore Governance and Transparency Index (SGTI), a leading
              index for assessing corporate governance practices of Singapore
              listed companies;
            </li>
            <li>
              Based on five domains within the framework: Board
              Responsibilities; Rights of Shareholders; Engagement of
              Stakeholders; Accountability and Audit; Disclosure and
              Transparency;
            </li>
          </ul>
        </li>
        <li>
          FINANCIAL RESILIENCE
          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              Efficiency and effectiveness of financial crisis response and
              financial planning;
            </li>
            <li>
              Shareholders&apos; Interest: shareholder value creation and return
              to shareholders, shareholder communications and meetings;
            </li>
          </ul>
        </li>
        <li>
          STRATEGIC AND OPERATIONAL EXCELLENCE
          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              Impacts of strategic and operational pivots since the onset of the
              pandemic;
            </li>
            <li>
              How strategic direction, changes in business models, risk
              management practices and other processes and systems were put in
              place quickly and executed efficiently to facilitate the
              transition of operations during the crisis;
            </li>
          </ul>
        </li>
        <li>
          PEOPLE MANAGEMENT
          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              People management and culture will be key metrics in this
              category;
            </li>
            <li>
              Consider staff engagement, health & safety, fair employment,
              performance measurement, incentives and other staff well-being
              practices;
            </li>
          </ul>
        </li>
        <li>
          SUSTAINABILITY & DIGITAL
          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              Promote greater environmental responsibility and sustainability
              initiatives;
            </li>
            <li>
              Leverage digital technology to pivot business and operating
              models;
            </li>
          </ul>
        </li>
      </ul>

      <p>
        <strong>Organisations</strong>
      </p>

      <p>The SCA is jointly organised by:</p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Institute of Singapore Chartered Accountants;</li>
        <li>Singapore Institute of Directors;</li>
        <li>The Business Times;</li>
      </ul>

      <p>The SCA is supported by:</p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Accounting and Corporate Regulatory Authority;</li>
        <li>Singapore Exchange;</li>
      </ul>

      <p>
        The partner organisations involved in the award organisation and
        detailed work are:
      </p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>CGS, NUS Business School;</li>
        <li>Deloitte;</li>
        <li>EY;</li>
        <li>Heidrick & Struggles;</li>
        <li>KPMG;</li>
        <li>PwC;</li>
      </ul>

      <p>The supporting partner is Citigate Dewe Rogerson.</p>

      <div className="mt-12 text-xs">
        <p>
          For more information, please contact the Singapore Institute of
          Directors:
        </p>

        <ul className="mb-6 list-none">
          <li>Mr Edwin Lee;</li>
          <li>Email: edwin@sid.org.sg;</li>
          <li>DID: 6011 0100 / 6422 1188;</li>
        </ul>

        <ul className="list-none">
          <li>Singapore Institute of Directors;</li>
          <li>168, #11-03 Robinson Rd, Capital Tower, 068912;</li>
        </ul>
      </div>
    </div>
  );
};

export default SpecialEditionPage;
